// MoveSectionForm.tsx

import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import {
  SectionWithId,
  GroupWithId,
  PropertyTemplatesWithIds,
} from './MetadataInterfaces';

interface MoveSectionFormProps {
  section: SectionWithId;
  currentPropertyType: string;
  currentGroup: GroupWithId;
  propertyTemplates: PropertyTemplatesWithIds;
  onSave: (
    section: SectionWithId,
    destinationPropertyType: string,
    destinationGroupId: string,
    isCopy: boolean,
  ) => void;
  onCancel: () => void;
}

const MoveSectionForm: React.FC<MoveSectionFormProps> = ({
  section,
  currentPropertyType,
  currentGroup,
  propertyTemplates,
  onSave,
  onCancel,
}) => {
  const [selectedPropertyType, setSelectedPropertyType] =
    useState(currentPropertyType);
  const [selectedGroupId, setSelectedGroupId] = useState(currentGroup.id);
  const [isCopy, setIsCopy] = useState(false);

  const propertyTypes = Object.keys(propertyTemplates);
  const groups = propertyTemplates[selectedPropertyType].groups;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(section, selectedPropertyType, selectedGroupId, isCopy);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <FormControl fullWidth margin="normal">
        <InputLabel>Property Type</InputLabel>
        <Select
          value={selectedPropertyType}
          onChange={(e) => setSelectedPropertyType(e.target.value)}
        >
          {propertyTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal">
        <InputLabel>Group</InputLabel>
        <Select
          value={selectedGroupId}
          onChange={(e) => setSelectedGroupId(e.target.value)}
        >
          {groups.map((group) => (
            <MenuItem key={group.id} value={group.id}>
              {group.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControlLabel
        control={
          <Checkbox
            checked={isCopy}
            onChange={(e) => setIsCopy(e.target.checked)}
          />
        }
        label="Copy section instead of moving"
      />
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} sx={{ mr: 1 }}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          {isCopy ? 'Copy Section' : 'Move Section'}
        </Button>
      </Box>
    </Box>
  );
};

export default MoveSectionForm;
